import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { DirectiveContent } from 'components/directive/directiveContent/DirectiveContent'
import { HeaderDashboard } from 'components/header/headerDashboard/HeaderDashboard'
import { SafeForm } from 'components/SafeForm'
import { WizardHeading } from 'components/wizard/WizardTypography'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SDirectiveContainer = styled.div`
  height: 100%;
  top: 0;
  flex-grow: 1;
  display: grid;
  grid-template-columns: 1fr ${pxToRem(800)}rem 1fr;
  grid-auto-rows: 100%;

  @media ${BREAKPOINTS.MD.max} {
    margin-bottom: ${pxToRem(10)}rem;
    max-height: unset;
    grid-auto-rows: unset;
    grid-template-rows: max-content 1fr;
    grid-template-columns: 1fr;
  }

  @media ${BREAKPOINTS.LG.max} and ${BREAKPOINTS.MD.min} {
    grid-template-columns: 3fr 2fr;
  }
`

export const SHeaderDashboard = styled(HeaderDashboard)`
  @media ${BREAKPOINTS.MD.max} {
    position: unset;
    width: 100%;
  }
`

export const SHeader = styled(WizardHeading)`
  margin-bottom: 3rem;
  @media ${BREAKPOINTS.MD.max} {
    margin-bottom: 0.5rem;
    font-size: 1.75rem;
  }
`

export const SDirectiveContent = styled(DirectiveContent)`
  flex: 1;
  @media ${BREAKPOINTS.MD.min} {
    margin-top: 1rem;
  }
`
export const directiveContentHeaderCss = css`
  align-items: 'center';

  @media ${BREAKPOINTS.MD.max} {
    margin-bottom: 1rem;
    margin-top: 0;
    padding-top: 2rem;
  }
`

export const SSafeForm = styled(SafeForm)`
  position: relative;
  height: 100%;
  padding-bottom: 2rem;
`

export const SMobileImageContainer = styled.div`
  width: ${pxToRem(160)}rem;
  @media ${BREAKPOINTS.MD.min} {
    width: ${pxToRem(320)}rem;
  }

  & > picture {
    width: 100%;
    & > img {
      width: 100%;
    }
  }
  & > img {
    width: 100%;
  }
  @media ${BREAKPOINTS.MD.min} {
    display: none;
  }
`

export const SRightPanel = styled.div`
  position: sticky;
  top: var(--h-header);
  height: 100%;
  max-height: calc(95vh - var(--h-header));
  max-width: 20rem;
  padding-right: 1rem;
  padding-top: 1rem;

  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;

  @media ${BREAKPOINTS.MD.max} {
    display: none;
  }
`
export const SDesktopImageContainer = styled.div`
  max-width: 100%;
  margin: 0 auto;

  & > img,
  & > picture > img {
    max-width: 100%;
  }
`

export const SButtonsContainer = styled.div`
  position: sticky;
  bottom: 1.5rem;
  left: 0;
  right: 0;
  display: flex;
  margin-top: 3rem;
  z-index: 2;
  justify-content: flex-end;

  & > button {
    &:not(:last-child) {
      margin-right: 1rem;
    }
  }

  @media ${BREAKPOINTS.MD.max} {
    background: var(--c-white);
    position: fixed;
    padding: 0.75rem;
    bottom: 0;

    box-shadow: var(--card-shadow);

    & > button {
      width: 100%;
    }
  }
`
